import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot,RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../auth.service/auth.service.component';
 
@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(private router:Router, private authService: AuthService ) {
    }
 
    canActivate(route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean | UrlTree {
        const currentUser = this.authService.login;
        console.log(currentUser);
        //const currentUsers = this.authService.currentUserValue;
        if (currentUser) {
            if (route.data.roles && route.data.roles.indexOf(currentUser.name) === -1) {
                // role not authorised so redirect to home page
                this.router.navigate(['/']);
                return false;
            }
        }
        if (!this.authService.isUserLoggedIn()) {
            alert('غير مصرح عرض هذه الصفحة دون تسجيل الدخول!');

            this.router.navigate(["login"], { queryParams: { retUrl: route.url } });
            return false;

            //var urlTree = this.router.createUrlTree(['login']);
            //return urlTree;
        }

        return true;
    }

}